import vue from 'vue'
import Jwt from '@/services/jwt-token'
import JwtNumerama from '@/services/jwt-token-numerama'
import storage from '@/services/session-storage'

const state = {
    check: Jwt.token != null,
    user: storage.getObject('user')
}

const mutations = {
    SET_USER(state, data) {
        storage.setObject('user', data)
        state.user = data
    },
    AUTHENTICATED(state) {
        state.check = true
    },
    UNAUTHENTICATED(state) {
        state.check = false;
        state.user = null;
        Jwt.token = null;
        JwtNumerama.token = null;
        storage.remove('user')
    }
}

const actions = {
    doLogin(context, {email, password}) {
        return Jwt.accessToken(email, password).then(() => {
            JwtNumerama.accessToken(email, password) //token numerama
        })
    },
    getUser(context) {
        vue.http.get('api/user').then(response => {
            context.commit('SET_USER', response.data)
        })
    },
    updateCheckuser(context) {
        context.commit('AUTHENTICATED')
    },
    setUserData(context, data) {
        context.commit('SET_USER', data)
    },
    logout(context) {
        context.commit('UNAUTHENTICATED')
    }
};

export default {
    state,
    mutations,
    actions
}
